import React, { ReactNode, createRef } from 'react';
import classNames from 'classnames';
import { eventsHandler } from './eventsHandler';
import { PopoverPortal } from './PopoverPortal';
import { getPosition, getStyles } from './positionUtils';

type Props = {
  children: () => ReactNode;
  element: HTMLElement;
  getCursorPosition: Function;
  isPopoverInsideModal: boolean;
};

type State = {
  show: boolean;
  tooltipStyle: {};
};

export class Popover extends React.Component<Props, State> {
  popoverRef = createRef<HTMLDivElement>();

  state: State = { show: false, tooltipStyle: {} };

  componentDidMount() {
    eventsHandler({
      linkElement: this.props.element,
      show: this.show,
      hide: this.hide,
    });
  }

  show = (cb: Function) => {
    const cursorPosition = this.props.getCursorPosition();
    const { tooltipYPosition, tooltipXPosition } = getPosition({
      window,
      cursorPosition,
    });
    const { tooltipStyle } = getStyles({
      tooltipYPosition,
      tooltipXPosition,
      window,
      cursorPosition,
    });
    this.setState({ show: true, tooltipStyle }, () =>
      cb(this.popoverRef.current),
    );
  };

  hide = () => {
    this.setState({ show: false });
  };

  render() {
    const { isPopoverInsideModal } = this.props;
    const { show, tooltipStyle } = this.state;
    return (
      show && (
        <PopoverPortal>
          <div
            ref={this.popoverRef}
            className={classNames('popover-pane', {
              'popover-in-modal': isPopoverInsideModal,
            })}
            style={{ display: 'block', ...tooltipStyle }}
          >
            {this.props.children()}
          </div>
        </PopoverPortal>
      )
    );
  }
}
